import {
    Badge, Button, DatePicker,
    Form, Input, message, Modal, Pagination, Radio, Select, Tabs, Tag, Timeline, Table, Tooltip
} from 'antd';
import axios from 'axios';
import dayjs from 'dayjs';
import moment from 'moment';
import React from 'react';
import RemoteSearchSelect from '@base-components/RemoteSearchSelect/RemoteSearchSelect.js';
import './index.scss';
import { hasCoopTaskPermission } from '@utils/agent';
import { checkAgentStatus } from '../../service/coopTask';


const { TabPane } = Tabs;
const { Option } = Select;
const { RangePicker } = DatePicker;

const BASE_API = ''

const levelMap = {
    0: '不紧急',
    1: '正常处理',
    2: '较紧急',
    3: '非常紧急'
}

const levelMapColor = {
    0: 'green',
    1: 'blue',
    2: 'orange',
    3: 'red'
}

// 记录类型，reply: 留言回复，todeal: 开始处理 ,completed: 已完成， closed: 已关闭， reopen: 重开
const typeMap = {
    'reply': '回复',
    'todeal': '开始处理',
    'completed': '完成任务',
    'closed': '关闭任务',
    'reopen': '重新开启',
}

const typeColorMap = {
    'reply': '#6F7C8B',
    'todeal': '#1890FF',
    'completed': '#1890FF',
    'closed': '#1890FF',
    'reopen': '#1890FF',
}

// 协作任务类型枚举
const coopTaskTypeMap = {
    SPEED_UP_PROCESS: { label: '催进度', value: 'SPEED_UP_PROCESS' },
    SPEED_UP_DEFLOSS: { label: '催定损', value: 'SPEED_UP_DEFLOSS' },
    SPEED_UP_REMIT: { label: '催打款', value: 'SPEED_UP_REMIT' },
    DEFLOSS_DISSENT: { label: '定损异议', value: 'DEFLOSS_DISSENT' },
    CLAIM_DISSENT: { label: '理赔异议', value: 'CLAIM_DISSENT' },
    COMMUNICATION: { label: '客户沟通', value: 'COMMUNICATION' },
    OTHERS: { label: '其他', value: 'OTHERS' },
    COMPLAIN: { label: '投诉', value: 'COMPLAIN' },
    WHOLE_CASE_CHECKED: { label: '整案核赔', value: 'WHOLE_CASE_CHECKED' },
    REOPEN: { label: '案件重开', value: 'REOPEN' },
}


//将秒数转换为时分秒格式
function formatSeconds(value) {

    var theTime = parseInt(value);// 秒
    var middle = 0;// 分
    var hour = 0;// 小时

    if (theTime > 60) {
        middle = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        if (middle > 60) {
            hour = parseInt(middle / 60);
            middle = parseInt(middle % 60);
        }
    }
    var result = "" + parseInt(theTime) + "";
    // var result ;
    if (theTime < 60) {
        // result = '00:00:' + theTime
        return '00:00:' + theTime
    }
    if (middle > 0) {
        result = "" + parseInt(middle) + ":" + result;
    }
    if (hour > 0) {
        result = "" + parseInt(hour) + ":" + result;
    }
    return result;
}

function filterAgents(agentList, filter) {
    const result = agentList.find(filter);
    if (result) {
        return result.agents
    }
    return [];
}

const agentColumns = [{
    title: '账号',
    dataIndex: 'loginName',
    width: 160
}, {
    title: '姓名',
    dataIndex: 'fullName',
    render: text => <p className="row-ellipsis" style={{ width: 160, margin: '0 auto' }}>{text}</p>
}, {
    title: '所属机构',
    dataIndex: 'orgName',
    render: text => <p className="row-ellipsis" style={{ width: 180, margin: '0 auto' }}>{text}</p>
}, {
    title: '状态',
    dataIndex: 'isOnline',
    render: isOnline => isOnline ? <span style={{ color: '#58B06A'}}>在线</span> : <span>离线</span>
}]
class TaskListModal extends React.Component {
    state = {
        visible: false,
        listData: {
            list: [],
            count: 0
        },
        coopTaskTypes: [],
        assignAgents: [],
        hasNewResult: [],
        formLayout: 'horizontal',
        isShowCreateForm: false,
        isShowDetail: false,
        detail: {},
        status: 'create',
        visibleMessage: false,
        message: '',
        modalTitle: '',
        activeKey: 'todeal',
        type: this.props.type || '',
        flowId: this.props.flowId || '',
        // 查询参数
        query: {
            agentId: this.props.agentId,
            // agentType: ['creator', 'handler'],
            leaveMsgType: undefined,
            isOverTime: undefined,
            taskType: undefined,
            kw: undefined,
            pageIndex: 1,
            pageSize: 10,
            sortBy: undefined,
            sortOrder: undefined,
            date: [moment().subtract(90, 'days'), moment()],
            orgAccount: undefined,
            creator: undefined,
            handler: this.props.assigned === 'all' ? undefined : (this.props.handler || undefined),
        },
        organization: [],
        agentList: [],
        report: {},
        activeAgents: {
            assignAgentName: '',
            agentList: []
        },
        activeAgentVisible: false,
        submitLoading: false,
        selectedAgent: []
    };
    assignResult = {};

    componentDidMount() {
        let orgAccount = undefined;
        this.getOrganization()
        // this.getAgentList()
        // this.setHandler()
        this.stateRefresh()
        const { currentAgentForTaskListModal } = this.props
        const { query } = this.state
        // currentAgentForTaskListModal && currentAgentForTaskListModal.agentRole && currentAgentForTaskListModal.agentRole.level && currentAgentForTaskListModal.agentRole.level === '2'
        if (currentAgentForTaskListModal && currentAgentForTaskListModal.agentRole && currentAgentForTaskListModal.agentRole.level && currentAgentForTaskListModal.agentRole.level === '2') {
            orgAccount = currentAgentForTaskListModal.orgAccount ? currentAgentForTaskListModal.orgAccount._id : undefined;
        }
        /**
         * 处理工单详情协作按钮点开逻辑，分为新建协作，待我处理，全部协作
         * 1、，打开新建协作内容，并搜索当前案件内容
         * 2、待我处理，日期清空，并触发筛选搜索
         */
        if (this.state.flowId) {
            switch (this.state.type) {
                case 'create':
                    this.setState({
                        activeKey: 'all',
                        isShowCreateForm: true,
                        query: {
                            ...this.state.query,
                            orgAccount
                        }
                    }, () => {
                        this.searchFlowId(this.state.flowId);
                        this.getCoopTaskList()
                    })
                default:
                    this.setState({
                        activeKey: 'all',
                        query: {
                            ...this.state.query,
                            date: [],
                            kw: this.state.flowId,
                            orgAccount
                        }
                    }, this.getCoopTaskList)
            }
            return;
        }
        this.getCoopTaskList()
    }

    handleReopen = () => {
        const { detail } = this.state
        axios({
            method: 'put',
            url: `${BASE_API}/api/lossAss/coopTask/reopen`,
            data: {
                taskId: detail._id,
                agentId: this.props.agentId,

            }
        }).then(res => {
            if (res.data.errCode === 0) {
                this.showDetails(detail)
            } else {
                message.error(res.data.errInfo)
            }
        }).catch(err => {
            message.error('请求/api/lossAss/coopTask/close失败')
        })
    }
    handleClose = () => {
        const { detail } = this.state
        axios({
            method: 'put',
            url: `${BASE_API}/api/lossAss/coopTask/close`,
            data: {
                taskId: detail._id,
                agentId: this.props.agentId,

            }
        }).then(res => {
            if (res.data.errCode === 0) {
                this.showDetails(detail)
            } else {
                message.error(res.data.errInfo)
            }
        }).catch(err => {
            message.error('请求/api/lossAss/coopTask/close失败')
        })
    }
    handleReply = () => {
        this.setState({
            modalTitle: '回复信息'
        })
        this.showModalMessage()
    }
    handleAccomplish = () => {
        this.setState({
            modalTitle: '确定已完成任务?'
        })
        this.showModalMessage()
    }
    showModalMessage = () => {
        this.setState({
            visibleMessage: true,
        });
    };

    handleOkMessage = e => {
        const { detail, message: msg, modalTitle } = this.state
        const url = modalTitle === '回复信息' ? `${BASE_API}/api/lossAss/coopTask/reply` : `${BASE_API}/api/lossAss/coopTask/complete`
        axios({
            method: 'put',
            url: url,
            data: {
                taskId: detail._id,
                agentId: this.props.agentId,
                content: msg
            }
        }).then(res => {
            if (res.data.errCode === 0) {
                this.setState({
                    visibleMessage: false,
                    message: ''
                });
                // this.getCoopTaskList()
                this.showDetails(detail)
            } else {
                message.error(res.data.errInfo)
            }
        }).catch(err => {
            // message.error( err || `请求${url}失败` )
        })
    };

    handleCancelMessage = e => {
        this.setState({
            visibleMessage: false,
            message: ''
        });
    };

    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    handleOk = e => {
        this.setState({
            visible: false,
        });
    };

    handleCancel = e => {
        // this.setState({
        //     visible: false,
        // });
        this.setState({
            coopTaskTypes: [],
            assignAgents: [],
        })
        this.props.hideTaskListModal()
    };

    handleChangeMessage = (e) => {
        this.setState({
            message: e.target.value
        })
    }

    callback = (key) => {
        const { query } = this.state

        this.setState({
            activeKey: key,
            // 查询参数
            query: {
                ...query,
                pageIndex: 1,
                pageSize: 10,
            },
            isShowCreateForm: false,
            isShowDetail: false,
        }, this.getCoopTaskList)
    }
    onChangePagination = page => {
        const { query } = this.state
        this.setState({
            query: {
                ...query,
                pageIndex: page
            }
        }, this.getCoopTaskList)
    };

    getCoopTaskList = () => {
        const { query, activeKey } = this.state;
        if (!this.props.agentId) {
            return
        }
        this.setState({
            listData: {
                ...this.state.listData,
                list: []
            }
        })
        if (!query.agentId) {
            return
        }
        axios({
            method: 'get',
            url: `${BASE_API}/api/lossAss/coopTask`,
            params: {
                ...query,
                state: activeKey === 'all' ? '' : activeKey,
                //  agentType: this.state.query.agentType.join(), 
                beginTime: query.date && query.date.length > 0 ? dayjs(query.date[0]).startOf('day').unix() : undefined,
                endTime: query.date && query.date.length > 0 ? dayjs(query.date[1]).endOf('day').unix() : undefined,
                taskTypes: query.taskType?.join(),
            }
        }).then(res => {
            if (res.data.errCode === 0) {
                this.setState({
                    listData: res.data
                })
            } else {
                message.error(res.data.errInfo)
            }
        }).catch(err => {
            message.error('请求/api/lossAss/coopTask失败')
        })
    }

    getCoopTaskTypes = (value) => {
        if (!this.props.agentId || !value) {
            return
        }
        axios({
            method: 'get',
            url: `${BASE_API}/api/lossAss/coopTask/types`,
            params: {
                flowId: value,
                agentId: this.props.agentId,
            }
        }).then(res => {
            if (res.data.errCode === 0) {
                this.setState({
                    report: res.data.result.report,
                    coopTaskTypes: res.data.result.coopTaskTypes,
                    assignAgents: [...res.data.result.assignAgents,

                        // {
                        //     "roleType": "customize",
                        //     "roleName": "自定义",
                        //     "agents": [
                        //         { "agentId": "坐席id", "fullName": "坐席姓名" },
                        //         { "agentId": "坐席id1", "fullName": "坐席姓名1" },

                        //     ]
                        // }
                    ],
                })
            } else {
                message.error(res.data.errInfo)
            }
        }).catch(err => {
            // message.error(err.message || '请求/api/lossAss/coopTask/types失败')
        })
    }

    stateRefresh = () => {
        if (!this.props.agentId) {
            return
        }
        axios({
            method: 'get',
            url: `${BASE_API}/api/lossAss/coopTask/stateRefresh`,
            params: {
                agentId: this.props.agentId,
            }
        }).then(res => {
            if (res.data.errCode === 0) {
                this.setState({
                    hasNewResult: res.data.result
                })
            } else {
                message.error(res.data.errInfo)
            }
        }).catch(err => {
            message.error('请求/api/lossAss/coopTask/stateRefresh失败')
        })
    }
    // 是否超时onChange
    handleChangeIsOverTime = (value) => {
        const { query } = this.state
        this.setState({
            query: {
                ...query,
                isOverTime: value
            }
        })
    }
    // 发起人onChange
    handleChangeCreator = (value) => {
        const { query } = this.state
        this.setState({
            query: {
                ...query,
                creator: value
            }
        })
    }
    // 处理人onChange
    handleChangeHandler = (value) => {
        const { query } = this.state
        this.setState({
            query: {
                ...query,
                handler: value
            }
        })
    }
    // 类型onChange
    handleChangeTaskType = (value) => {
        const { query } = this.state
        this.setState({
            query: {
                ...query,
                taskType: value
            }
        })
    }
    // 是否留言onChange
    handleChangeLeaveMsgType = (value) => {
        const { query } = this.state
        this.setState({
            query: {
                ...query,
                leaveMsgType: value
            }
        })
    }
    // 排序字段onChange
    handleChangeSortBy = (value) => {
        const { query } = this.state
        this.setState({
            query: {
                ...query,
                sortBy: value
            }
        })
    }
    // 降序、升序onChange
    handleChangeSortOrder = (value) => {
        const { query } = this.state
        this.setState({
            query: {
                ...query,
                sortOrder: value
            }
        })
    }
    // 受理号onChange
    onChangeKw = (e) => {
        const { query } = this.state
        this.setState({
            query: {
                ...query,
                kw: e.target.value
            }
        })
    }
    onSearch = (value) => {
        const { query } = this.state
        this.setState({
            query: {
                ...query,
                kw: value
            }
        }, () => {
            this.getCoopTaskList()
        })
    }
    // 校验协作坐席是否可用
    checkAgentActive = async () => {
        const { agentId, assiggAgentId, assignAgentRole } = this.assignResult;
        try {
            const { result } = await checkAgentStatus({
                agentId,
                assiggAgentId,
                assignAgentRole
            })
            const { onJob, assignAgentName, agentList } = result;
            if (!onJob) {
                this.setState({
                    activeAgentVisible: true,
                    submitLoading: false,
                    activeAgents: {
                        agentList,
                        assignAgentName
                    }
                })
            }
            return onJob;
        } catch {}
    }

    // 新建/更新协作任务
    submitCooptask = () => {
        const { status } = this.state;
        axios({
            method: status === 'update' ? 'put' : 'post',
            url: `${BASE_API}/api/lossAss/coopTask`,
            data: this.assignResult,
        }).then(res => {
            this.setState({
                submitLoading: false
            })
            if (res.data.errCode === 0) {
                message.success('操作成功')
                this.getCoopTaskList();
                this.showDetails({
                    _id: res.data.result._id
                })
            } else {
                message.error(res.data.errInfo)
            }
        }).catch(err => {
            this.setState({
                submitLoading: false
            })
            message.error('请求/api/lossAss/coopTask失败')
        })
    }

    handleSubmit = e => {
        const { assignAgents, status, detail } = this.state
        const $this = this
        // e.preventDefault();
        this.formRef.validateFields().then(async values => {
            this.setState({
                submitLoading: true
            })
            if (values.assiggAgentId) {
                this.assignResult = {
                    ...values,
                    assignAgentRole: 'customize',
                    agentId: $this.props.agentId,
                    id: status === 'update' ? detail._id : undefined,
                }
            } else {
                this.assignResult = {
                    ...values,
                    assiggAgentId: assignAgents.find(item => item.roleType === values.assignAgentRole).agentId,
                    agentId: $this.props.agentId,
                    id: status === 'update' ? detail._id : undefined,
                }
            }
            // 先校验坐席是否可用，若可用，继续调用创建协作任务；若不可用，则弹框显示可操作的坐席列表
            try {
                const isActive = await this.checkAgentActive(this.assignResult);
                if (isActive) {
                    this.submitCooptask();
                }
            } catch(err) {
                this.assignResult = {};
                this.setState({
                    submitLoading: false
                })
            }
        }).catch((err) => {
            console.log(err)
        });
    };
    handleCancelSubmit = () => {
        this.setState({
            activeAgentVisible: false,
            selectedAgent: []
        })
    }
    handleContinueSubmit = () => {
        this.assignResult = {
            ...this.assignResult,
            assiggAgentId: this.state.selectedAgent
        }
        this.setState({
            activeAgentVisible: false,
            activeAgents: {
                assignAgentName: '',
                agentList: []
            }
        })
        this.submitCooptask();
    }

    handleCreate = () => {
        // 当前操作如果不是在新建，则清空任务选项
        this.setState({
            status: 'create',
            isShowCreateForm: true,
            isShowDetail: false,
            coopTaskTypes: [],
            assignAgents: []
        }, () => {
            this.formRef.resetFields()
        })
    }
    showDetails = (record) => {
        // this.setState({
        //     coopTaskTypes: [],
        //     assignAgents: [],
        // })
        axios({
            method: 'get',
            url: `${BASE_API}/api/lossAss/coopTask/detail`,
            params: {
                id: record._id,
                agentId: this.props.agentId,
            }
        }).then(res => {
            if (res.data.errCode === 0) {
                // 显示详情
                // this.props.setAllValues(res.data.result)
                this.setState({
                    detail: res.data.result,
                    isShowDetail: true,
                    isShowCreateForm: false
                })
                this.getCoopTaskTypes(res.data.result.flowId)
                // this.searchFlowId(res.data.result.flowId)
                // this.getCoopTaskList()
                // this.stateRefresh()
                this.props.getCoopTaskAboutAgent && this.props.getCoopTaskAboutAgent()

            } else {
                message.error(res.data.errInfo)
            }


        }).catch(err => {

            message.error('请求/api/lossAss/coopTask/detail失败')
        })

    }
    handleEdit = () => {
        this.setState({
            status: 'update',
        }, () => {
            this.setState({
                isShowCreateForm: true,
                isShowDetail: false,
            })
        })
    }
    // 开始处理案件
    startProcessing = () => {
        const { detail } = this.state
        axios({
            method: 'put',
            url: `${BASE_API}/api/lossAss/coopTask/todeal`,
            data: {
                taskId: detail._id,
                agentId: this.props.agentId,
            }
        }).then(res => {
            if (res.data.errCode === 0) {
                message.success('操作成功')
                // this.getCoopTaskList()
                this.showDetails(detail)
                this.stateRefresh()


            } else {
                message.error(res.data.errInfo)
            }


        }).catch(err => {
            message.error('请求/api/lossAss/coopTask/todeal失败')
        })
    }
    searchFlowId = (value) => {

        // 搜索案件重置表单内容（除案件号）
        this.formRef.setFieldsValue({
            flowId: value,
            type: undefined,
            level: undefined,
            detail: "",
            assignAgentRole: "",
            assiggAgentId: ""
        })
        this.getCoopTaskTypes(value)
    }
    handleView = async () => {
        const { actions } = this.props
        const { detail } = this.state
        if (this.props.agentId !== detail.reportAgentId) {
            // let report = await actions.getCurrentReport(detail.flowId)

            // report = report.payload
            // if (report) {
            //     if (report.ownCarLoss) {
            //         actions.selectedCar(report.ownCarLoss._id)
            //     } else {
            //         actions.selectedCar(report._id)
            //     }
            // }
            this.props.history.push(`/customerCenter/ReportDetail/${detail.flowId}`);
            // actions.selectedReport(report)
            // actions.reportPageOrForm("reportForm")
            this.props.hideTaskListModal()
        } else {
            this.props.history.push(`/workBench/ReportDetail/${detail.flowId}`);
            actions.getCreateReport('update')
            actions.changeActiveReportTab('1')
            actions.getCurrentReport(detail.flowId)
            this.props.hideTaskListModal()
        }



    }

    setHandler = () => {
        const { query } = this.state
        const { currentAgentForTaskListModal, agentId } = this.props
        if (((currentAgentForTaskListModal && currentAgentForTaskListModal && currentAgentForTaskListModal.agentRole && currentAgentForTaskListModal.agentRole.level && currentAgentForTaskListModal.agentRole.level === '2') || (currentAgentForTaskListModal && currentAgentForTaskListModal && currentAgentForTaskListModal.agentRole && currentAgentForTaskListModal.agentRole.level && currentAgentForTaskListModal.agentRole.level === '3'))) {
            return
        }

        setTimeout(() => {
            this.setState({
                query: {
                    ...query,
                    handler: agentId
                }
            }, () => {
            })
        }, 1000);

    }

    setOrgAccount = () => {
        const { currentAgentForTaskListModal } = this.props
        const { query } = this.state
        // currentAgentForTaskListModal && currentAgentForTaskListModal.agentRole && currentAgentForTaskListModal.agentRole.level && currentAgentForTaskListModal.agentRole.level === '2'
        if (currentAgentForTaskListModal && currentAgentForTaskListModal.agentRole && currentAgentForTaskListModal.agentRole.level && currentAgentForTaskListModal.agentRole.level === '2') {
            setTimeout(() => {
                this.setState({
                    query: {
                        ...query,
                        orgAccount: currentAgentForTaskListModal && currentAgentForTaskListModal.orgAccount && currentAgentForTaskListModal.orgAccount._id
                    }
                }, () => {
                    this.getCoopTaskList()
                })
            }, 1000);

        }

    }
    // 日期onChange
    onChangeDate = (date, dateString) => {
        const { query } = this.state
        this.setState({
            query: {
                ...query,
                date
            }
        })

    }
    // 获取全部可选机构
    getOrganization = () => {
        const { currentAgentForTaskListModal } = this.props
        const tenant = currentAgentForTaskListModal && currentAgentForTaskListModal.tenant ? currentAgentForTaskListModal.tenant._id : ''
        axios({
            url: `/api/lossAss/organizitions/simple?pageIndex=1&pageSize=1000&searchTenant=${tenant}`,
            method: 'get',
        }).then(res => {
            if (res.data.errCode === 0) {
                this.setState({
                    organization: res.data.result.list
                })
            }
        }).catch(err => {
            message.error(err.message)
        })
    }

    // 获取全部可选坐席
    getAgentList = () => {
        const { currentAgentForTaskListModal } = this.props
        const { orgAccount } = this.state
        const tenant = currentAgentForTaskListModal && currentAgentForTaskListModal.tenant ? currentAgentForTaskListModal.tenant._id : ''
        axios({
            url: `/api/agents/simple?pageIndex=1&pageSize=20000&searchTenant=${tenant}&searchOrgAccount=${orgAccount ? orgAccount : ''}`,
            method: 'get',
        }).then(res => {
            if (res.data.errCode === 0) {
                this.setState({
                    agentList: res.data.result.agents
                })
            }
        }).catch(err => {
            message.error(err.message)
        })
    }
    // 机构onChange
    handleChangeOrgAccount = (value) => {
        const { query } = this.state
        const { currentAgentForTaskListModal } = this.props
        this.setState({
            query: {
                ...query,
                orgAccount: value
            }
        }, () => {

            this.refCreator.fetchRemoteData('',)
            this.refHandler.fetchRemoteData('',)
        })
    }
    // 导出
    handleDownload = () => {
        const { query } = this.state;
        if (!this.props.agentId) {
            return
        }
        axios({
            method: 'get',
            url: `${BASE_API}/api/lossAss/coopTask/export`,
            params: {
                ...query,
                //  agentType: this.state.query.agentType.join(),
                beginTime: query.date && query.date.length > 0 ? dayjs(query.date[0]).startOf('day').unix() : undefined,
                endTime: query.date && query.date.length > 0 ? dayjs(query.date[1]).endOf('day').unix() : undefined
            }
        }).then(res => {
            if (res.data.errCode === 0) {
                const url = res.data.result.url
                window.open(url)
            } else {
                message.error(res.data.errInfo)
            }
        }).catch(err => {
            message.error('请求/api/lossAss/coopTask失败')
        })
    }
    // 任务类型onChange
    handleChangeType = (type) => {
        const { currentAgentForTaskListModal } = this.props
        const { assignAgents, report: { state, subState } } = this.state
        // 催进度
        if (['SPEED_UP_PROCESS',].includes(type)) {
            //默认勾选资料或理赔
            //报案受理/资料收集/补充资料
            assignAgents.map(item => item.disabled = false)
            this.formRef.setFieldsValue({ assignAgentRole: "" })
            if (['untreated', 'holdedOn', 'returned'].includes(state)) {
                assignAgents.map(item => item.disabled = true)
                assignAgents.find(item => item.roleType === 'collector').disabled = false
                this.formRef.setFieldsValue({ assignAgentRole: "collector" })
            }
            //已查勘/理赔中/理赔补充/已定损  打款失败/银行退票/重新打款
            if (['surveied', 'claiming', 'claimReturned', 'checked'].includes(state) ||
                ['remittFailed', 'refound', 'reRemitt',].includes(subState)

            ) {
                assignAgents.map(item => item.disabled = true)
                assignAgents.find(item => item.roleType === 'claim').disabled = false
                this.formRef.setFieldsValue({ assignAgentRole: "claim" })
            }
            this.setState({
                assignAgents: [...assignAgents,]
            })
            return
        }
        //催定损，定损异议
        if (['SPEED_UP_DEFLOSS', 'DEFLOSS_DISSENT'].includes(type)) {
            //默认勾选定损坐席
            assignAgents.map(item => item.disabled = true)
            assignAgents.find(item => item.roleType === 'defLoss').disabled = false
            this.setState({
                assignAgents: [...assignAgents,]
            })
            this.formRef.setFieldsValue({ assignAgentRole: "defLoss" })
            return
        }
        //理赔异议
        if (['CLAIM_DISSENT',].includes(type)) {
            //默认勾选理赔处理人
            assignAgents.map(item => item.disabled = true)
            assignAgents.find(item => item.roleType === 'claim').disabled = false
            this.setState({
                assignAgents: [...assignAgents,]
            })
            this.formRef.setFieldsValue({ assignAgentRole: "claim" })
            return
        }
        //客户沟通
        if (['COMMUNICATION',].includes(type)) {
            //默认勾选客服
            assignAgents.map(item => item.disabled = true)
            assignAgents.find(item => item.roleType === 'coopTask').disabled = false
            this.setState({
                assignAgents: [...assignAgents,]
            })
            this.formRef.setFieldsValue({ assignAgentRole: "coopTask" })
            return
        }
        //催打款
        if (['SPEED_UP_REMIT',].includes(type)) {
            //默认勾选理赔处理人
            assignAgents.map(item => item.disabled = true)
            assignAgents.find(item => item.roleType === 'claim').disabled = false
            this.setState({
                assignAgents: [...assignAgents,]
            })

            this.formRef.setFieldsValue({ assignAgentRole: "claim" })
            return
        }
        //整案核赔
        if (['WHOLE_CASE_CHECKED',].includes(type)) {
            assignAgents.map(item => item.disabled = true)
            assignAgents.find(item => item.roleType === 'customize').disabled = false
            this.setState({
                assignAgents: [...assignAgents,]
            })
            //默认勾选自定义处理人
            this.formRef.setFieldsValue({ assignAgentRole: "customize" })
            return
        }
        //其他
        if (['OTHERS',].includes(type)) {
            assignAgents.map(item => item.disabled = false)

            if (assignAgents.some(item => item.agentId === currentAgentForTaskListModal._id)) {
                assignAgents.filter(item => item.agentId === currentAgentForTaskListModal._id).map(item => item.disabled = true)
            }
            //账号权限勾选‘接收协作任务客服’的坐席不可指派给客服
            if (hasCoopTaskPermission(currentAgentForTaskListModal)) {
                assignAgents.find(item => item.roleType === 'coopTask').disabled = true
            }
            this.setState({
                assignAgents: [...assignAgents,]
            })
            this.formRef.setFieldsValue({ assignAgentRole: undefined, assiggAgentId: undefined })
            return
        }
        else {
            assignAgents.map(item => item.disabled = false)
            this.setState({
                assignAgents: [...assignAgents,]
            })
            this.formRef.setFieldsValue({ assignAgentRole: undefined, assiggAgentId: undefined })
            return
        }
    }

    handleSelectAgent = (selectedRowKeys) => {
        this.setState({
            selectedAgent: selectedRowKeys
        })
    }

    render() {
        const { assignAgents, coopTaskTypes, listData, hasNewResult, formLayout, activeAgents, isShowCreateForm, detail, isShowDetail, status, query, activeKey, agentList, type, activeAgentVisible, submitLoading, selectedAgent } = this.state
        const { currentAgentForTaskListModal } = this.props
        const tenant = currentAgentForTaskListModal && currentAgentForTaskListModal.tenant ? currentAgentForTaskListModal.tenant._id : ''


        return (
            <div className='task-list-wrapper'>

                <Modal
                    visible={true}
                    title=""
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    width='90%'
                    footer={null}
                    wrapClassName='task-list-modal'
                    destroyOnClose
                    maskClosable={false}
                // forceRender
                >
                    <Tabs onChange={this.callback} activeKey={activeKey}>
                        <TabPane tab={<Badge dot={hasNewResult.length !== 0 && hasNewResult.find(item => item.value === 'todeal').hasNew}><a href="#">新任务</a></Badge>} key="todeal"></TabPane>
                        <TabPane tab={<Badge dot={hasNewResult.length !== 0 && hasNewResult.find(item => item.value === 'dealing').hasNew}><a href="#">处理中</a></Badge>} key="dealing"></TabPane>
                        <TabPane tab={<Badge dot={hasNewResult.length !== 0 && hasNewResult.find(item => item.value === 'completed').hasNew}><a href="#">已完成</a></Badge>} key="completed"></TabPane>
                        <TabPane tab={<Badge dot={hasNewResult.length !== 0 && hasNewResult.find(item => item.value === 'closed').hasNew}><a href="#">已关闭</a></Badge>} key="closed"></TabPane>
                        <TabPane tab={<Badge dot={hasNewResult.length !== 0 && hasNewResult.find(item => item.value === 'reopen').hasNew}><a href="#">重开</a></Badge>} key="reopen"></TabPane>
                        <TabPane tab={<Badge><a href="#">全部</a></Badge>} key="all"></TabPane>
                    </Tabs>
                    <div className='tabPane-container'>
                        <div className='filtration'>
                            <RangePicker
                                allowClear
                                size='small'
                                style={{ width: 220 }}
                                value={query.date}
                                onChange={this.onChangeDate}
                            />
                            {/* 登录坐席.agentRole.level === '2' //机构管理员
                                        登录坐席.agentRole.level === '3' //公司管理员 */}

                            {
                                ((currentAgentForTaskListModal && currentAgentForTaskListModal && currentAgentForTaskListModal.agentRole && currentAgentForTaskListModal.agentRole.level && currentAgentForTaskListModal.agentRole.level === '2') || (currentAgentForTaskListModal && currentAgentForTaskListModal && currentAgentForTaskListModal.agentRole && currentAgentForTaskListModal.agentRole.level && currentAgentForTaskListModal.agentRole.level === '3')) ? <Select
                                    allowClear
                                    size='small'
                                    value={query.orgAccount}
                                    placeholder='全部机构'
                                    style={{ minWidth: 120, marginLeft: 10 }}
                                    onChange={this.handleChangeOrgAccount}
                                    disabled={currentAgentForTaskListModal && currentAgentForTaskListModal && currentAgentForTaskListModal.agentRole && currentAgentForTaskListModal.agentRole.level && currentAgentForTaskListModal.agentRole.level === '2'}

                                >

                                    {
                                        this.state.organization.map(item => <Option key={item._id} value={item._id}>{item.orgName}</Option>)
                                    }

                                </Select> : null
                            }
                            {/* <Select
                                allowClear
                                size='small'
                                placeholder='发起人'
                                style={{ width: 120 }}
                                value={query.creator}
                                onChange={this.handleChangeCreator}
                                onPopupScroll={(e) => {
                                    this.handlePopupScroll(e);
                                }}
                            >
                                {agentList.map(item => <Option value={item._id} key={item._id}>{item.fullName}</Option>)}
                            </Select> */}
                            <RemoteSearchSelect
                                allowClear
                                size='small'
                                placeholder='发起人'
                                style={{ width: 120 }}
                                value={query.creator}
                                onChange={this.handleChangeCreator}
                                url="/api/agents/simple"
                                paramName='searchStr'
                                fieldName='agents'
                                textName='fullName'
                                valueName='_id'
                                query={`&searchOrgAccount=${this.state.query.orgAccount || ''}&searchTenant=${tenant || ''}`}
                                pageSize={50}
                                ref={(refCreator) => this.refCreator = refCreator}
                            />
                            {/* <Select
                                allowClear
                                size='small'
                                placeholder='处理人'
                                style={{ width: 120 }}
                                value={query.handler}
                                onChange={this.handleChangeHandler}
                            >
                                {agentList.map(item => <Option value={item._id} key={item._id}>{item.fullName}</Option>)}
                            </Select> */}
                            <RemoteSearchSelect
                                allowClear
                                size='small'
                                placeholder='处理人'
                                style={{ width: 120 }}
                                value={query.handler}
                                onChange={this.handleChangeHandler}
                                url="/api/agents/simple"
                                paramName='searchStr'
                                fieldName='agents'
                                textName='fullName'
                                valueName='_id'
                                query={`&searchOrgAccount=${this.state.query.orgAccount || ''}&searchTenant=${tenant || ''}`}
                                pageSize={50}
                                ref={(refHandler) => this.refHandler = refHandler}

                            />
                            <Select
                                allowClear
                                size='small'
                                placeholder='是否超时'
                                style={{ width: 120 }}
                                value={query.isOverTime}
                                onChange={this.handleChangeIsOverTime}>
                                <Option value="1">超时</Option>
                                <Option value="0">未超时</Option>

                            </Select>
                            <Select
                                allowClear
                                mode='multiple'
                                size='small'
                                placeholder='全部类型'
                                style={{ minWidth: 120 }}
                                value={query.taskType}
                                onChange={this.handleChangeTaskType}>
                                {
                                    Object.keys(coopTaskTypeMap).map(item => <Option value={coopTaskTypeMap[item].value} key={coopTaskTypeMap[item].value}>{coopTaskTypeMap[item].label}</Option>)
                                }
                            </Select>
                            <Select
                                allowClear
                                size='small'
                                placeholder='是否留言'
                                style={{ width: 120 }}
                                onChange={this.handleChangeLeaveMsgType}
                                value={query.leaveMsgType}
                            >
                                <Option value="new">未读留言</Option>
                                <Option value="reply">已留言</Option>
                                <Option value="qita">其他</Option>
                            </Select>
                            <Select
                                size='small'
                                placeholder='排序字段'
                                style={{ width: 120 }}
                                onChange={this.handleChangeSortBy}
                                value={query.sortBy}
                            >
                                <Option value="ctime">创建时间</Option>
                                <Option value="utime">变更时间</Option>
                                <Option value="level">紧急度</Option>
                                <Option value="timeRemain">剩余时间</Option>
                            </Select>
                            <Select
                                size='small'
                                placeholder='降序/升序'
                                style={{ width: 120 }}
                                onChange={this.handleChangeSortOrder}
                                value={query.sortOrder}
                            >
                                <Option value="desc">降序</Option>
                                <Option value="asc">升序</Option>
                            </Select>
                            <Input.Search
                                placeholder="输入受理号"
                                enterButton="搜索"
                                size="small"
                                value={query.kw}
                                onChange={this.onChangeKw}
                                style={{ width: 220 }}
                                onSearch={this.onSearch}
                            />
                            <Button
                                type="primary"
                                size="small"
                                onClick={this.handleCreate}
                            >
                                新建
                            </Button>
                            {
                                ((currentAgentForTaskListModal && currentAgentForTaskListModal && currentAgentForTaskListModal.agentRole && currentAgentForTaskListModal.agentRole.level && currentAgentForTaskListModal.agentRole.level === '2') || (currentAgentForTaskListModal && currentAgentForTaskListModal && currentAgentForTaskListModal.agentRole && currentAgentForTaskListModal.agentRole.level && currentAgentForTaskListModal.agentRole.level === '3'))
                                &&
                                <Button
                                    type="primary"
                                    size="small"
                                    onClick={this.handleDownload}
                                >
                                    导出
                                </Button>
                            }
                        </div>
                        <div className='flex-box cooperate-task-list'>
                            <div className='list-wrapper'>
                                <ul className='list'>
                                    {
                                        listData.list && listData.list.map(item =>
                                            <li className={`list-item ${detail._id === item._id ? 'selected' : ''}`} onClick={() => this.showDetails(item)} key={item._id}>
                                                <div className={`list-item-title ${item.isUnRead === '1' ? 'unread' : ''}`}>
                                                    <span className="text"> 【{coopTaskTypeMap[item.type].label}】{item.flowId}</span>
                                                    {/* 处理中 */}
                                                    {
                                                        item.state === 'dealing' ? <i className="iconfont icon-processing"></i> : null
                                                    }
                                                    {/* 新留言 */}
                                                    {
                                                        item.hasNewLeaveMsg === '1' ? <i className="iconfont icon-new-message"></i> : null
                                                    }
                                                    {/* 已关闭 */}
                                                    {
                                                        item.state === 'closed' ? <i className="iconfont icon-complete icon-closed"></i> : null
                                                    }
                                                    {/* 新任务 */}
                                                    {
                                                        item.state === 'todeal' ? <i className="iconfont icon-new"></i> : null
                                                    }
                                                    {/* 已超时 */}
                                                    {
                                                        item.isOverTime === '1' ? <i className="iconfont icon-overtime"></i> : null
                                                    }
                                                    {/* 已回复 */}
                                                    {
                                                        item.isReply === '1' ? <i className="iconfont icon-replied"></i> : null
                                                    }
                                                    {/* 已完成 */}
                                                    {
                                                        item.state === 'completed' ? <i className="iconfont icon-complete"></i> : null
                                                    }
                                                    {/* 已重开 */}
                                                    {
                                                        item.state === 'reopen' ? <i className="iconfont icon-reopen"></i> : null
                                                    }
                                                    <Tag color={levelMapColor[item.level]} style={{ position: 'absolute', right: 0, top: 0 }}>{levelMap[item.level]}</Tag>
                                                </div>
                                                <div className='list-item-detail'>{item.detail.substr(0, 40)}</div>
                                                <div className='list-item-fullName'>
                                                    <span style={{ marginLeft: 0 }}>发起:{item.creator && item.creator.fullName}</span>
                                                    <span style={{ marginLeft: 10 }}>处理:{item.handler && item.handler.fullName}</span>

                                                    <span style={{ position: 'absolute', right: 0, top: 0 }}>{dayjs(item.ctime).format("YYYY.MM.DD HH:mm")}</span>
                                                </div>
                                            </li>)
                                    }
                                </ul>
                                <Pagination
                                    current={this.state.query.pageIndex} onChange={this.onChangePagination}
                                    total={listData.count}
                                    showTotal={total => `共 ${total} 条,${listData.pageTotal}页`}
                                />
                            </div>

                            {
                                isShowCreateForm ? <div className='create-form'>
                                    <Form layout={formLayout} onFinish={this.handleSubmit} ref={ref => this.formRef = ref} labelCol={{ span: 4 }} wrapperCol={{ span: 14 }} initialValues={status === 'update' ? {
                                        flowId: detail.flowId,
                                        type: detail.type,
                                        level: detail.level,
                                        detail: detail.detail,
                                        assignAgentRole: detail.handlerRoleType,
                                        assiggAgentId: detail.assiggAgentId
                                    } : {}}>

                                        <Form.Item label="案件受理号" name="flowId" rules={[{ required: true, message: '请输入案件受理号!' }]}>
                                            <Input.Search
                                                disabled={status === 'update' && (this.props.agentId === (detail.creator && detail.creator._id))}
                                                onSearch={this.searchFlowId}
                                                style={{ height: 24 }}
                                                size='small'
                                                enterButton="搜索"
                                                placeholder='请输入' />
                                        </Form.Item>
                                        {
                                            coopTaskTypes.length ? <React.Fragment>
                                                <Form.Item label="任务类型" name="type" rules={[{ required: true, message: '请选择任务类型!' }]}>
                                                    <Select
                                                        size='small'
                                                        placeholder='请选择'
                                                        onChange={this.handleChangeType}
                                                        disabled={status === 'update' && (this.props.agentId === (detail.creator && detail.creator._id))}

                                                    >
                                                        {
                                                            coopTaskTypes.map(item => <Option value={item.value} key={item.value}>{item.label}</Option>)
                                                        }
                                                        {/* <Option value={'customize'}>{'整案核赔'}</Option> */}
                                                    </Select>
                                                </Form.Item>
                                                <Form.Item label="紧急度" name="level" rules={[{ required: true, message: '请选择紧急度!' }]}>
                                                    <Select
                                                        size='small'
                                                        placeholder='请选择紧急度'
                                                    >
                                                        <Option value={3}>非常紧急</Option>
                                                        <Option value={2}>较紧急</Option>
                                                        <Option value={1}>正常处理</Option>
                                                        <Option value={0}>不紧急</Option>
                                                    </Select>
                                                </Form.Item>
                                                <Form.Item label="任务描述" name="detail" rules={[{ required: true, message: '请输入任务描述!' }]}>
                                                    <Input.TextArea rows={3} size='small' placeholder='请输入任务描述' />
                                                </Form.Item>
                                                <Form.Item shouldUpdate={(prevValues, curValues) => prevValues.type !== curValues.type} noStyle>
                                                    {
                                                        ({ getFieldValue }) => {
                                                            const type = getFieldValue('type');
                                                            // 任务类型为整案核赔、案件重开，显示的是自定义处理人；其余任务类型展示不同坐席
                                                            return ['REOPEN', 'WHOLE_CASE_CHECKED'].includes(type) ? <Form.Item label="指派处理人" name="assiggAgentId" rules={[{ required: true, message: '请选择指派处理人!' }]}>
                                                                <Select
                                                                    size='small'
                                                                    style={{ width: 160 }}
                                                                    placeholder="请选择指派处理人"
                                                                >
                                                                    {
                                                                        filterAgents(assignAgents, item => item.roleName === '自定义').map(agent => <Option value={agent.agentId}>{agent.fullName}</Option>)
                                                                    }
                                                                </Select>
                                                            </Form.Item> : <Form.Item label="指派处理人" name="assignAgentRole" rules={[{ required: true, message: '请选择指派处理人!' }]}>
                                                                <Radio.Group size='small' >
                                                                    {assignAgents.map(item =>
                                                                        item.roleName !== '自定义' &&
                                                                        <Radio disabled={item.disabled} value={item.roleType} key={item.roleType}>
                                                                            {item.roleName}
                                                                            {
                                                                                item.roleName !== '客服' && (item.fullName) && <span>({item.roleName !== '客服' && (item.fullName)})</span>
                                                                            }
                                                                        </Radio>
                                                                    )}
                                                                </Radio.Group>
                                                            </Form.Item>
                                                        }
                                                    }
                                                </Form.Item>
                                            </React.Fragment> : null
                                        }
                                        <Form.Item
                                            shouldUpdate
                                            wrapperCol={{ span: 14, offset: 4 }}
                                        >
                                            {
                                                ({ getFieldsValue }) => {
                                                    const { flowId = '', type = '', level = '', assignAgentRole = '', assiggAgentId = '', detail = '' } = getFieldsValue(['flowId', 'type', 'level', 'assignAgentRole', 'assiggAgentId', 'detail']);

                                                    return <Button disabled={(!assignAgentRole && !assiggAgentId) || !detail || !flowId || (level === null || level === undefined ? true : false) || !type} htmlType="submit" type="primary" loading={submitLoading}>提交任务</Button>
                                                }
                                            }
                                        </Form.Item>
                                    </Form>
                                </div> : null
                            }
                            {
                                isShowDetail ? <div className='task-detail'>
                                    <div className='list-item-title' style={detail.isUnRead === '1' ? { color: '#F36262' } : { color: 'rgba(111, 124, 139, 1)' }}>
                                        【{coopTaskTypeMap[detail.type].label}】

                                        {detail.flowId}
                                        <Tag color={levelMapColor[detail.level]} style={{ marginLeft: 10 }}>{levelMap[detail.level]}</Tag>
                                        {
                                            detail.remainTime > 0 ? <Tag style={{ marginLeft: 10 }} color='red'>截止时间:{detail.etime && dayjs(detail.etime).format("YYYY.MM.DD HH:mm")}</Tag> : null
                                        }
                                        {
                                            detail.remainTime < 0 ? <Tag style={{ marginLeft: 10 }} color='red'>已超时:{detail.remainTime && formatSeconds(Math.abs(detail.remainTime))}</Tag> : null
                                        }


                                        {
                                            (this.props.agentId === (detail.creator && detail.creator._id)) &&
                                            <Button style={{ marginLeft: 10 }} onClick={this.handleEdit} size='small' icon={<i className="iconfont icon-edit" />}>编辑</Button>
                                        }


                                    </div>

                                    <div className='list-item-fullName'>
                                        <span>发起人:{detail.creator && detail.creator.fullName}</span>
                                        <span style={{ marginLeft: 10 }}>处理人:{detail.handler && detail.handler.fullName}</span>

                                        <span style={{ marginLeft: 20 }}>创建时间:</span> <span >{dayjs(detail.ctime).format("YYYY.MM.DD HH:mm")}</span>


                                    </div>
                                    <div className='list-item-detail'>{detail.detail}</div>

                                    {/*  */}
                                    <div style={{ marginTop: 40 }}></div>
                                    <div className='timeline-wrapper'>
                                        <Timeline>

                                            {
                                                detail.transferRecords.map((item, index) =>
                                                    <Timeline.Item key={index}>
                                                        <span>{dayjs(item.time).format("YYYY.MM.DD HH:mm")}</span>
                                                        <span style={{ marginLeft: 20 }}>{item.agentName}</span>
                                                        <span style={{ marginLeft: 20, color: typeColorMap[item.type] }}>{typeMap[item.type]}</span>
                                                        <div>{item.content}</div>


                                                    </Timeline.Item>)
                                            }
                                        </Timeline>
                                    </div>

                                    <div className='footer-button'>
                                        {
                                            !['todeal'].includes(detail.state) &&
                                            <Button style={{ marginRight: 10 }} onClick={this.handleView} type="primary">案件详情</Button>
                                        }
                                        {
                                            !['completed', 'closed'].includes(detail.state) &&
                                            (this.props.agentId === (detail.creator && detail.creator._id))
                                            &&
                                            <Button onClick={this.handleClose} style={{ marginRight: 10 }} type="danger">关闭任务</Button>
                                        }
                                        {
                                            ['completed', 'closed'].includes(detail.state) &&

                                            (this.props.agentId === (detail.creator && detail.creator._id)) &&

                                            <Button onClick={this.handleReopen} style={{ marginRight: 10 }}>重新开启</Button>
                                        }
                                        {
                                            !['completed', 'closed', 'todeal'].includes(detail.state) && <Button onClick={this.handleReply} style={{ marginRight: 10 }}>回复</Button>
                                        }
                                        {
                                            !['completed', 'closed', 'todeal'].includes(detail.state) && (this.props.agentId !== (detail.creator && detail.creator._id)) &&
                                            <Button onClick={this.handleAccomplish} type="primary">完成任务</Button>
                                        }
                                    </div>
                                    {/* 判断 creator agentId */}
                                    {/* 显示开始处理按钮的条件：是新任务 并且 不是发起人   */}
                                    {
                                        ['todeal'].includes(detail.state) &&
                                        (this.props.agentId !== (detail.creator && detail.creator._id)) &&
                                        <div className='start-processing' onClick={this.startProcessing}>
                                            <i className="iconfont icon-edit-fill" style={{ fontSize: 30 }} />
                                            <div>开始处理</div>
                                        </div>
                                    }
                                </div> : null
                            }
                        </div>
                    </div>
                </Modal>
                <Modal
                    title={this.state.modalTitle}
                    visible={this.state.visibleMessage}
                    onOk={this.handleOkMessage}
                    onCancel={this.handleCancelMessage}

                >
                    <Input.TextArea onChange={this.handleChangeMessage} value={this.state.message} rows={4} />
                </Modal>
                <Modal visible={activeAgentVisible} title={`员工${activeAgents.assignAgentName}已离职，可将协作任务转给以下人员，也可以返回重新选择`} onOk={this.handleContinueSubmit} onCancel={this.handleCancelSubmit} okText="确认提交" cancelText="返回" width={700} okButtonProps={{ disabled: !selectedAgent.length }} destroyOnClose maskClosable={false} bodyStyle={{ maxHeight: 500, overflowY: 'auto'}}>
                    <Table rowKey="agentId" columns={agentColumns} dataSource={activeAgents.agentList} rowSelection={{
                        type: 'radio',
                        onChange: this.handleSelectAgent,
                        selectedRowKeys: selectedAgent
                        }} pagination={false} />
                </Modal>
            </div>
        );
    }
}


export default TaskListModal


